export default "__VITE_ASSET__DkWDQv3u__"